import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import { getOptionsForAttr } from './coderefs';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

export function PIPAttendantCareSelector({attr, additionalOptions, dataType, ...props}) {

  let applicationModel = useContext(ModelContext);
  let line = applicationModel.getValue(`lines{lineCd:CollectorVehicle}`);
  
  const formContext = useContext(FormContext);
  let attribute = formContext.metadata[attr];

  let lineOptions = getOptionsForAttr(attribute).list;

  if (additionalOptions && additionalOptions.length) {
    lineOptions = [...lineOptions, ...additionalOptions];
  }

  let pip = line.pIP;
  if(line.pIPAttendantCareLimit == undefined || line.pIPAttendantCareLimit == ""){
    if(!(pip == "Rejected" || pip == "Unlimited")){
      line.pIPAttendantCareLimit = "10000";
      props.value = "10000";
    } else {
      line.pIPAttendantCareLimit = "0";
      props.value = "0";
    }
  }

  if(dataType && dataType === 'SelectUpdate'){
    let selected = null;
    let children = lineOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>);
    const options = React.Children.map(children, el => {
        if (!el.props) {
          return null;
        }
        const obj = {
          label: el.props.children,
          value: el.props.value
        };
        if (el.props.value === props.value) {
          selected = obj;
        }
        return obj;
    });
    
    const form = useContext(FormContext);
    const actions = useContext(ApplicationActionsContext);
    const { setValueByAttr, getValueByAttr } = form;
    const previousValue = selected;
    const [selectedValue, setSelectedValue] = useState(previousValue);

    const handleChange = (selected) => {
      setValueByAttr(attr, selected.value);
      setSelectedValue(selected);
      actions.saveApplication();
    };

    if (pip == "Rejected" || pip == "Unlimited") {
      return <div>N/A</div>;
    }

    return <Select
        {...props}
        aria-label="Select"
        styles={customStylesUpdater}
        title="Select"
        openMenuOnFocus
        placeholder={null}
        options={options}
        value={selected}
        onChange={handleChange}
        components={{
          IndicatorSeparator: () => null,
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 4,
          zIndex: 3,
          colors: {
            ...theme.colors,
            primary25: 'rgb(0, 115, 157, 0.1)',
            primary: 'rgba(0, 115, 157, 0.5)',
            neutral30: 'rgba(0, 115, 157, 0.5)',
          },
        })}
      />
  }
  return <PortalSelect {...props}>
    {
      lineOptions.map(({value, name}) => <PortalSelectOption value={value}>
        {name}
      </PortalSelectOption>)
    }
  </PortalSelect>;
}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

PIPAttendantCareSelector.schema = BASIC_ELEMENT_SCHEMA;